
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-monitoring",
      function () {
        return require("private-next-pages/content-monitoring/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-monitoring"])
      });
    }
  